











































































import Vue from "vue";
import { $eventsBus } from "@/main";
import { Item } from "../../classes/Item";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";

export default Vue.extend({
  name: "Dropzone",
  components: { BaseInput },
  data: function () {
    return {
      hightlight: false,
      enabled: true,
      inputURLString: "",
      loadingLink: false,
    };
  },
  props: {
    topHeightShift: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
  },
  methods: {
    stopInputURLString() {
      if (this.inputURLString === "") {
        return;
      }
      this.loadingLink = true;
      this.axios
        .post(
          "/v2.0/upload/uploadMediaYandex",
          {
            link: this.inputURLString,
          },
          {
            headers: {
              Accept: "*/*",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          let lastAspectRatio =
            this.items.length !== 0
              ? this.items[0].innerVideoResolutionX /
                this.items[0].innerVideoResolutionY
              : 0;
          let filesToImport = [];

          res.data.forEach((fileObject) => {
            let fileAspectRatio =
              fileObject.resolution_x / fileObject.resolution_y;
            if (
              lastAspectRatio !== 0 &&
              lastAspectRatio.toFixed(2) !== fileAspectRatio.toFixed(2)
            ) {
              this.$emit("error");
            } else {
              lastAspectRatio = fileAspectRatio;
              filesToImport.push(fileObject);
            }
          });

          if (filesToImport.length !== 0) {
            this.$store.commit("itemsUploaded", filesToImport);
            $eventsBus.$emit("saveUserWorkspace");
            this.$store.commit("addNewStateToHistory");
          }

          this.inputURLString = "";
          this.loadingLink = false;
        })
        .catch((err) => {
          console.log(err);
          alert("Error upload from URL!");
          this.inputURLString = "";
          this.loadingLink = false;
        });
    },
    //Dropzone
    openFileSelection(): void {
      if (!this.$data.enabled) return;
      (<HTMLElement>this.$refs.fileInput).click();
    },
    onDragOver(event: DragEvent): void {
      if (!this.$data.enabled) return;
      event.preventDefault();
      this.$data.hightlight = true;
    },
    onDragLeave(event: DragEvent): void {
      //TODO
      if (
        event.target &&
        (<HTMLElement>event.target).className.includes("dropzone-container") &&
        event.relatedTarget &&
        ((<HTMLElement>event.relatedTarget).className.includes(
          "dropzone-container"
        ) ||
          (<HTMLElement>event.relatedTarget).className.includes("left-panel"))
      ) {
        return;
      }
      this.$data.hightlight = false;
    },
    onDrop(event: DragEvent): void {
      if (!this.$data.enabled) return;
      event.preventDefault();
      const files = event.dataTransfer.files;
      this.validateAndUploadFiles(files);
    },
    onFileChanged(event: any) {
      let files: FileList = event.target.files;
      this.validateAndUploadFiles(files);
      event.target.value = "";
    },
    validateAndUploadFiles(files): void {
      let result: File[] = [];
      const maxCount = 30;
      let maxIndex = files.length > maxCount ? maxCount : files.length;
      for (var i = 0; i < maxIndex; i++) {
        result.push(<File>files.item(i));
      }
      this.uploadDropFiles(result);
    },
    uploadDropFiles(files: File[]) {
      //let uploadingId = `f${(~~(Math.random() * 1e8)).toString(16)}`;
      let filesToUpload = [];
      files.forEach((f) => {
        let uploadingId = `f${(~~(Math.random() * 1e8)).toString(16)}`;
        filesToUpload.push({
          uploadingId: uploadingId,
          file: f,
        });
      });
      this.$data.hightlight = false;
      console.log(filesToUpload);
      if (filesToUpload && filesToUpload.length) {
        let correctFilesToUpload = this.getCorrectFiles(filesToUpload);

        correctFilesToUpload.reduce((promiseChain, fileToUpload) => {
          return promiseChain.then(
            () =>
              new Promise((resolve) => {
                let lastAspectRatio =
                  this.items.length !== 0
                    ? this.items[0].innerVideoResolutionX /
                      this.items[0].innerVideoResolutionY
                    : 0;
                this.checkFileHasSameAspectRatio(
                  fileToUpload.file,
                  lastAspectRatio,
                  (resolve) => {
                    this.$emit("error");
                    resolve();
                  },
                  (videoFileParameters, resolve) => {
                    this.uploadFiles([fileToUpload]);
                    this.items.push(
                      Item.createNewItemByFile(
                        fileToUpload.file,
                        videoFileParameters,
                        fileToUpload.uploadingId
                      )
                    );
                    if (!this.previewItem) {
                      this.$store.commit("changeSelectItem", this.items[0]);
                    }
                    resolve();
                  },
                  resolve
                );
              })
          );
        }, Promise.resolve());
      }
    },
    //Files uploading
    getCorrectFiles(filesToUpload): any[] {
      const maxFileSize = 1 * 1024 * 1024 * 1024;
      return filesToUpload.filter((f) => {
        if (f.file.size > maxFileSize) {
          console.log("error");
          return false;
        } else {
          return true;
        }
      });
    },
    uploadFiles(files): void {
      if (files.length === 0) {
        return;
      }
      const uploadProgress = (uploadingId) => (progressEvent) => {
        let percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        let item = this.items.find(
          (i) => i.loadingParameters.uploadingId === uploadingId
        );
        item.loadingParameters.process = percentCompleted;
        console.log(percentCompleted);
      };
      const config = {
        onUploadProgress: uploadProgress(files[0].uploadingId).bind(this),
        ///cancelToken: this.$axiosCancelTokenSource.token,
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };

      for (var i = 0; i < files.length; i++) {
        let fileItem = files[i];
        let data = new FormData();
        data.append("files[0]", fileItem.file);
        data.append("sessionId", this.$store.state.userInfo.sessionId);

        let route = "/v2.0/upload/uploadMedia";
        let uploadingId = fileItem.uploadingId;

        this.axios
          .post(route, data, config)
          .then((res) => {
            console.log(res);
            this.checkAndLoadFiles(res.data, uploadingId);
          })
          .catch((err) => {
            if ((<string>err.toString()).toLowerCase().includes("cancel")) {
              console.info("File uploading request canceled");
            } else {
              console.log(err);
            }
          });
      }
    },
    checkFileHasSameAspectRatio(
      file,
      lastAspectRatio,
      errorCallback,
      correctCallback,
      resolve
    ) {
      let fileType = file.type;
      console.log("type", fileType);
      if (fileType.indexOf("video") == -1) {
        return;
      }
      let fileSrc = window.URL.createObjectURL(file);
      let videoEl: HTMLVideoElement = document.createElement("video");
      videoEl.style.display = "none";
      document.body.append(videoEl);
      videoEl.src = fileSrc;

      let videoTagRef = videoEl;
      videoTagRef.addEventListener("loadedmetadata", function (e) {
        console.log(videoTagRef.videoWidth, videoTagRef.videoHeight);
        if (
          lastAspectRatio !== 0 &&
          lastAspectRatio.toFixed(2) !==
            (videoTagRef.videoWidth / videoTagRef.videoHeight).toFixed(2)
        ) {
          errorCallback(resolve);
        } else {
          lastAspectRatio = videoTagRef.videoWidth / videoTagRef.videoHeight;
          correctCallback(
            {
              duration: videoTagRef.duration,
              videoWidth: videoTagRef.videoWidth,
              videoHeight: videoTagRef.videoHeight,
            },
            resolve
          );
        }
        videoEl.remove();
      });
    },
    checkAndGetFileData(file, dataCallback) {
      let fileType = file.type;
      console.log("type", fileType);
      if (fileType.indexOf("video") == -1) {
        return;
      }
      let fileSrc = window.URL.createObjectURL(file);
      let videoEl: HTMLVideoElement = document.createElement("video");
      videoEl.style.display = "none";
      document.body.append(videoEl);
      videoEl.src = fileSrc;

      let videoTagRef = videoEl;
      videoTagRef.addEventListener("loadedmetadata", function (e) {
        dataCallback({
          duration: videoTagRef.duration,
          videoWidth: videoTagRef.videoWidth,
          videoHeight: videoTagRef.videoHeight,
        });
        videoEl.remove();
      });
    },
    checkAndLoadFiles(data, uploadingId): void {
      let indexesToDelete = [];
      let lastErrorText = "";
      let files = data;
      files.forEach((uploadedFile) => {
        if (!uploadedFile.success) {
          var invalidFileIndex = files.indexOf(uploadedFile);
          indexesToDelete.push(invalidFileIndex);
          var errorText = uploadedFile.error;
          console.error(
            "File upload error " + uploadedFile.name + ": " + errorText
          );
          lastErrorText = errorText;
        }
      });
      let allCount = files.length;
      indexesToDelete.sort((a, b) => b - a).forEach((i) => files.splice(i, 1));

      if (files.length === 0) {
        if (allCount > 1) {
          console.log("All files upload error");
        } else {
          console.log(lastErrorText);
        }
        //TODO
      } else {
        console.log(
          "Upload complete!" +
            (indexesToDelete.length > 0
              ? " Errors: " + indexesToDelete.length + "/" + allCount
              : "")
        );
        //this.itemsUploaded(files);
        this.$store.commit("updateItemsAfterUpload", {
          uploadingId: uploadingId,
          files: files,
        });
        $eventsBus.$emit("saveUserWorkspace");
        this.$store.commit("addNewStateToHistory");
      }
    },
    //deprecated
    itemsUploaded(data): void {
      /* this.$store.commit("itemsUploaded", data);
      $eventsBus.$emit("saveUserWorkspace");
      this.$store.commit("addNewStateToHistory"); */
    },
  },
});
